import React from "react";
import {OrderToolPanelContainer} from "./styled";
import {BarekamIcon, IconVariants} from "../../../../components/icon/barekam-icon";
import {ViewIcons} from "../../../../components/icon/variants";
import BarekamButton, {FilterButtons,} from "../../../../components/button";
import {useAppDispatch, useAppSelector} from "../../../../../redux/store";
import {changeOrderView} from "../../../../../redux/slices/orders-slice";
import {OrderViewEnum} from "../../../enums/order/view.enum";

const TableViewSwitch = ({onFilterClicked, isWarehouseWorker}: {
    onFilterClicked: () => void,
    isWarehouseWorker: boolean,

}) => {
    const {matchesPhone} = useAppSelector(state => state.deviceReducer);
    const dispatch = useAppDispatch();

    return (
        <OrderToolPanelContainer>
            {matchesPhone
                ? <BarekamButton type={FilterButtons.SECONDARY_BUTTON}
                                 onClick={() => onFilterClicked()}>
                    <BarekamIcon variant={IconVariants.filter}/>
                </BarekamButton>
                : ''
            }

            {!isWarehouseWorker ?
                <>
                    <BarekamButton type={FilterButtons.SECONDARY_BUTTON}
                                   onClick={() => dispatch(changeOrderView(OrderViewEnum.list))}>
                        <BarekamIcon variant={ViewIcons.list}/>
                    </BarekamButton>

                    <BarekamButton type={FilterButtons.SECONDARY_BUTTON}
                                   onClick={() => dispatch(changeOrderView(OrderViewEnum.cards))}>
                        <BarekamIcon variant={ViewIcons.card}/>
                    </BarekamButton>
                </> :
                ''
            }

        </OrderToolPanelContainer>
    )
}

export default TableViewSwitch;
